import { Dialog } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { ReportType } from "../../../../../api/types/svTypes";
import { UnsavedReportContext } from "../../sv/contexts/UnsavedReportContext";
import SmartViewAppPage from "../../sv/SmartViewAppPage";
import { toDashboardPath } from "./dashboardPath";

const supportedReportTypes = [ReportType.Tabular];

const ArtifactReportWindow = () => {
  const navigate = useNavigate();
  const { pathname, key } = useLocation();

  const closeWindow = () => (key === "default" ? navigate(toDashboardPath(pathname), { replace: true }) : navigate(-1));

  return (
    <Dialog open fullScreen sx={{ m: 2 }} slotProps={{ paper: { sx: { borderRadius: 1 } } }}>
      <UnsavedReportContext value={{ onClose: closeWindow }}>
        <SmartViewAppPage supportedReportTypes={supportedReportTypes} />
      </UnsavedReportContext>
    </Dialog>
  );
};

export default ArtifactReportWindow;
